import { MasterDataTable } from "@/components/MasterDataTable";
import { useSourceTypes, useSourceTypeAdmin } from "@/hooks/useMasterData";

const SourceTypes = () => {
  const { data: sourceTypes = [], isLoading } = useSourceTypes();
  const admin = useSourceTypeAdmin();

  return (
    <MasterDataTable
      items={sourceTypes.map((i) => ({ id: i.id, label: i.name, is_active: i.is_active }))}
      valueLabel="Name"
      isLoading={isLoading}
      onCreate={(name) => admin.create.mutateAsync(name)}
      onUpdate={(id, data) => admin.update.mutateAsync({ id, data })}
      onDelete={(id) => admin.remove.mutateAsync(id)}
    />
  );
};

export default SourceTypes;
